const SET_LOGIN_SESSION_INFO = 'session/SET_LOGIN_SESSION_INFO';
const SET_HAS_TRACKED_LOGIN_SESSION = 'session/HAS_TRACKED_LOGIN_SESSION';

type SessionAction =
  | {
      type: typeof SET_LOGIN_SESSION_INFO;
      payload: Partial<SessionState>;
    }
  | {
      type: typeof SET_HAS_TRACKED_LOGIN_SESSION;
    };

export type SessionState = {
  isPersisted?: boolean;
  hasTrackedLoggedInSession?: boolean;
};

export function setLoginSessionInfo(value: Partial<SessionState>) {
  return {
    type: SET_LOGIN_SESSION_INFO,
    payload: value,
  };
}

export function setHasTrackedLoginSession() {
  return {
    type: SET_HAS_TRACKED_LOGIN_SESSION,
  };
}

export default function sessionReducer(
  state: SessionState = {},
  action: SessionAction
): SessionState {
  switch (action.type) {
    case SET_LOGIN_SESSION_INFO:
      return {
        ...state,
        ...action.payload,
      };
    case SET_HAS_TRACKED_LOGIN_SESSION:
      return {
        ...state,
        hasTrackedLoggedInSession: true,
      };
    default:
      return state;
  }
}
